// extracted by mini-css-extract-plugin
export default {"extraIdentityOfAddingUserContainer":"ExtraIdentityTabInAddUser_extraIdentityOfAddingUserContainer__VnxZl"};